import Navigator from './Navigator';
import NavigatorSeries from './NavigatorSeries';
import NavigatorXAxis from './NavigatorXAxis';
import NavigatorYAxis from './NavigatorYAxis';
import { provideChart, provideSeries } from 'react-jsx-highcharts';
var ChartNavigator = provideChart(Navigator);
ChartNavigator.Series = provideSeries(NavigatorSeries);
ChartNavigator.XAxis = NavigatorXAxis;
ChartNavigator.YAxis = NavigatorYAxis;
export default ChartNavigator;